var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7014 24L18.9375 30.382L18.9375 17.618L31.7014 24Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9375 8H38.9375V10H42.9375V8ZM32.5375 8H36.5375V10H32.5375V8ZM26.1375 8H30.1375V10H26.1375V8ZM19.7375 8H23.7375V10H19.7375V8ZM13.3375 8H17.3375V10H13.3375V8ZM6.9375 8H10.9375V10H6.9375V8ZM6.9375 36V12H42.9375V36H6.9375ZM6.9375 38V40H10.9375V38H6.9375ZM13.3375 40H17.3375V38H13.3375V40ZM19.7375 40H23.7375V38H19.7375V40ZM26.1375 40H30.1375V38H26.1375V40ZM32.5375 40H36.5375V38H32.5375V40ZM38.9375 40H42.9375V38H38.9375V40ZM6.9375 6C5.83293 6 4.9375 6.89543 4.9375 8V40C4.9375 41.1046 5.83293 42 6.9375 42H42.9375C44.0421 42 44.9375 41.1046 44.9375 40V8C44.9375 6.89543 44.0421 6 42.9375 6H6.9375Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.3a8083c3240089e57ae6fbd0159662dd.svg";
export { ForwardRef as ReactComponent };